<template>
  <div style="display: flex;flex-direction: column;width: 100%;">
    <!-- 基本信息 -->
    <div class="order-input-wrap">
      <base-tag label="基本信息"></base-tag>
      <!-- 联系人姓名 -->
      <div class="input-orthodontics" style="margin-left: 3px;">
        <div class="input-label">
          <span>下单名称：</span>
        </div>
        <div class="input-value">
          {{ orderDetail.demContact }}
        </div>
      </div>

      <!-- 联系方式 -->
      <div class="input-orthodontics">
        <div class="input-label">
          <span>联系方式：</span>
        </div>
        <div class="input-value">
          {{ orderDetail.demPhone }}
        </div>
      </div>

      <!-- 患者姓名 -->
      <div class="input-orthodontics">
        <div class="input-label">
          <span>患者姓名：</span>
        </div>
        <div class="input-value">
          {{ orderDetail.demPatient }}
        </div>
      </div>

      <!-- 患者性别 -->
      <div class="input-orthodontics">
        <div class="input-label">
          <span>患者性别：</span>
        </div>
        <div class="input-value">
          {{ orderDetail.demSex == '00' ? '男' : '女' }}
        </div>
      </div>

      <!-- 患者年龄 -->
      <div class="input-orthodontics">
        <div class="input-label">
          <span>患者年龄：</span>
        </div>
        <div class="input-value">
          {{ orderDetail.orthodonticsData.patientAge }}
        </div>
      </div>
    </div>
    <div class="order-input-wrap">
      <base-tag class="makeCondition" label="矫治需求"></base-tag>
      <div class="case-class">
        <div class="case-class-box" style="line-height: 50px;font-size: 15px;width: 50%;margin-left: 1.3%;">
          <p class="case-class-item" style="float:left;">
            <span>矫治牙列</span>
            <el-checkbox-group v-model="orderDetail.orthodonticsData.countCalList" class="molar-item-check"
              style="line-height: 50px;width: 430px;" disabled>
              <el-checkbox style="margin-right: 13.5%;" label="00">上颌5-5</el-checkbox>
              <el-checkbox style="margin-right: 13.5%;" label="01">下颌5-5</el-checkbox>
              <el-checkbox style="margin-right: 13.5%;" label="02">上下颌5-5</el-checkbox>
            </el-checkbox-group>
          </p>
        </div>
        <!-- 加急费 -->
        <div class="input-rush" style="margin: 0 4.5% 0 1%;">
          <div class="input-label">
            <span>加急费：</span>
          </div>
          <div class="input-value">
            {{ parseMoney(orderDetail.orderRushFee) }}
          </div>
        </div>
        <!-- 总价 -->
        <div class="input-cal">
          <div class="input-label">
            <span>总价：</span>
          </div>
          <div class="input-value">
            {{ parseMoney(orderDetail.orderAmount) }} 元
          </div>
        </div>
      </div>
      <div class="canvasImg">
        <img :src="orthodonticsData.correctiveImages.join(',')" v-if="orthodonticsData.correctiveImages!=null">
      </div>
      <!-- 备注信息 -->
      <div class="order-input-wrap">
        <base-tag label="其他要求"></base-tag>
        <div class="input-textarea" style="width: 95%;">
          <el-input type="textarea" :rows="2" placeholder="请输入备注信息" v-model="orderDetail.orderRemark" readonly />
        </div>
      </div>
      <!-- 临床检查 -->
      <div class="order-input-wrap">
        <base-tag label="临床检查信息与要求（非必填项）"></base-tag>
        <div class="dental-relationship">
          <div class="molar-tooth">
            <div class="molar-Str">
              磨牙关系
            </div>
            <div class="molar-select">
              <p class="molar-select-item">
                <span class="direction">右侧</span>
                <el-checkbox-group v-model="orthodonticsData.molarRelationShipRight" class="molar-item-check" disabled>
                  <el-checkbox label="01">I类</el-checkbox>
                  <el-checkbox label="02">II类</el-checkbox>
                  <el-checkbox label="03">III类</el-checkbox>
                </el-checkbox-group>
              </p>
              <p class="molar-select-item">
                <span class="direction">左侧</span>
                <el-checkbox-group v-model="orthodonticsData.molarRelationShipLeft" class="molar-item-check" disabled>
                  <el-checkbox label="01">I类</el-checkbox>
                  <el-checkbox label="02">II类</el-checkbox>
                  <el-checkbox label="03">III类</el-checkbox>
                </el-checkbox-group>
              </p>
            </div>
          </div>
          <div class="molar-tooth">
            <div class="molar-Str">尖牙关系</div>
            <div class="molar-select">
              <p class="molar-select-item">
                <span class="direction">右侧</span>
                <el-checkbox-group v-model="orthodonticsData.canineRelationShipRight" class="molar-item-check" disabled>
                  <el-checkbox label="01">中性</el-checkbox>
                  <el-checkbox label="02">远中</el-checkbox>
                  <el-checkbox label="03">近中</el-checkbox>
                </el-checkbox-group>
              </p>
              <p class="molar-select-item">
                <span class="direction">左侧</span>
                <el-checkbox-group v-model="orthodonticsData.canineRelationShipLeft" class="molar-item-check" disabled>
                  <el-checkbox label="01">中性</el-checkbox>
                  <el-checkbox label="02">远中</el-checkbox>
                  <el-checkbox label="03">近中</el-checkbox>
                </el-checkbox-group>
              </p>
            </div>
          </div>
        </div>
        <div class="case-class">
          <div class="case-class-box" style="margin:2% 0 0 2.5%;line-height: 40px;font-size: 15px;">
            <p class="case-class-item" style="float:left;">
              <span style="width: 65px;letter-spacing: 1px;">病例分类</span>
              <el-checkbox-group v-model="orthodonticsData.caseClass" class="molar-item-check" style="line-height: 40px;" disabled>
                <el-checkbox v-for="(val, key) in caseList" class="item-check" style="margin-right: 15px"
                  :label="val.index" :key="key">{{ val.label }}</el-checkbox>
              </el-checkbox-group>
            </p>
          </div>
        </div>
      </div>
      <div class="order-detail-upload" style="min-height: calc(100vh - 713px);margin-top: 20px;">
        <!-- 牙列间隙 -->
        <div style="margin-top:25px;">
          <span class="title-Str">牙列间隙</span>
          <el-checkbox label="00" v-model="orthodonticsData.interdentalSpace" disabled
            style="margin-left: 15px;">全部关闭</el-checkbox>
          <el-checkbox label="01" v-model="orthodonticsData.interdentalSpace" disabled>保留间隙</el-checkbox>
          <input class="input-join" v-model="orthodonticsData.interdentalSpaceRemark" placeholder="输入说明" readonly>
          <span class="title-Str" style="margin-left: -50px">后牙反𬌗</span>
          <el-checkbox v-model="orthodonticsData.toothRetroversion" label="00" disabled>保持</el-checkbox>
          <el-checkbox v-model="orthodonticsData.toothRetroversion" label="01" disabled>纠正</el-checkbox>
        </div>
        <div class="dental-jaw" style="margin-top: 40px;">
          <div class="jaw-Str">中线</div>
          <div class="dental-jaw">
            <div style="line-height:30px;margin-left: 6px;width: 62%;">
              <div style="height:30px;">
                <span style="margin-right:25px;">上颌</span>
                <el-checkbox label="00" v-model="orthodonticsData.centerUpper" disabled
                  style="margin:0 20px 0 22px ;"
                >保持</el-checkbox>
                <el-checkbox label="01" v-model="orthodonticsData.centerUpper" disabled
                >改善</el-checkbox>
                <span style="margin-left:25px;">近中(+)</span>
                <input v-model="orderDetail.orthodonticsData.centerUpperNearMid" readonly
                  style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                <span style="margin-left:15px;">远中(-)</span>
                <input v-model="orderDetail.orthodonticsData.centerUpperFarAway" readonly
                  style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
              </div>
              <div style="height:30px;">
                <span style="margin-right:25px;">下颌</span>
                <el-checkbox label="00" v-model="orthodonticsData.centerDown" disabled
                  style="margin:0 20px 0 22px ;"
                >保持</el-checkbox>
                <el-checkbox label="01" v-model="orthodonticsData.centerDown" disabled>改善</el-checkbox>
                <span style="margin-left:25px;">近中(+)</span>
                <input v-model="orderDetail.orthodonticsData.centerDownNearMid" readonly
                  style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                <span style="margin-left:15px;">远中(-)</span>
                <input v-model="orderDetail.orthodonticsData.centerDownFarAway" readonly
                  style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
              </div>
            </div>
            <!-- 覆𬌗 -->
            <div style="margin-left:-21px;line-height:30px;">
              <div>
                <span class="title-Str">覆𬌗</span>
                <el-checkbox v-model="orthodonticsData.coverUp" label="00" disabled>保持</el-checkbox>
                <el-checkbox v-model="orthodonticsData.coverUp" label="01" disabled>改善</el-checkbox>
                <input v-model="orderDetail.orthodonticsData.coverUpParam" style="border-bottom: 1px solid black;
                background: #F7F7F7;width:75px;text-align:center;" readonly>mm
              </div>
              <div>
                <span class="title-Str">覆盖</span>
                <el-checkbox v-model="orthodonticsData.cover" label="00" disabled>保持</el-checkbox>
                <el-checkbox v-model="orthodonticsData.cover" label="01" disabled>改善</el-checkbox>
                <input v-model="orderDetail.orthodonticsData.coverParam" style="border-bottom: 1px solid black;
                background: #F7F7F7;width:75px;text-align:center;" readonly>mm
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseTag from '@/components/BaseTag';
export default {
  data() {
    return {
      caseList: [
        { label: '拥挤', index: '00' },
        { label: '牙列间隙', index: '01' },
        { label: '前突', index: '02' },
        { label: '开牙合', index: '03' },
        { label: '深覆牙合', index: '04' },
        { label: '深覆盖', index: '05' },
        { label: '前牙反牙合', index: '06' },
        { label: '后牙反牙合', index: '07' },
        { label: '后牙锁牙合', index: '08' }
      ],
      orthodonticsData:[],
    }
  },
  props: {
    orderDetail: {
      type: Object,
    }
  },
  methods: {
    getDataList() {
      // 获取对应数据
      let list = ['canineRelationShipLeft', 'canineRelationShipRight',
        'molarRelationShipLeft', 'molarRelationShipRight',
        'toothRetroversion', 'centerUpper', 'centerDown',
        'countCalList', 'cover', 'coverUp', 'caseClass',
        'interdentalSpace', 'centerUpper', 'centerDown']
      let list2 = ['centerDownFarAway', 'centerDownNearMid', 'centerUpperFarAway',
        'centerUpperNearMid', 'coverParam', 'coverUpParam']
      this.orthodonticsData = this.orderDetail.orthodonticsData
      // console.log('demContact:',this.orderDetail.demContact)
      // console.log('demSex:',this.orderDetail.demSex)
      // console.log('dataScan:',this.orderDetail.dataScan)
      // console.log('dataMouth:',this.orderDetail.dataMouth)
      // console.log('dataCBCT:',this.orderDetail.dataCbct)
      // console.log('--------------------------------------',)
      // console.log('orth:',this.orthodonticsData)
      // console.log('dataFaceImg:',this.orthodonticsData.dataFaceImg)
      // console.log('dataVideo:',this.orthodonticsData.dataVideo)
      // console.log('correctiveImages:',this.orthodonticsData.correctiveImages)
      for (var key in this.orderDetail.orthodonticsData) {
        // if(list.includes(key)){
        //   console.log(key+':',this.orthodonticsData[key])
        // }
        if (list.includes(key) && this.orderDetail.orthodonticsData[key] != ''&& this.orderDetail.orthodonticsData[key] != null) {
          this.orthodonticsData[key] = this.orderDetail.orthodonticsData[key].split(',')
        }
        // 设置默认为 0 的值为null
        if (list2.includes(key)) {
          // console.log(key+':',this.orthodonticsData[key])
          this.orthodonticsData[key] = this.orthodonticsData[key] == 0 ? '' : this.orthodonticsData[key]
        }
      }
      this.orthodonticsData.correctiveImages = JSON.parse(this.orderDetail.orthodonticsData.correctiveImages)
    }
  },
  created() {
    this.getDataList();
  },
  
  components: {
    BaseTag,
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/style/orthodontics.scss";

.input-orthodontics,
.input-rush,
.input-cal {
  float: left;
  display: flex;
  font-size: 13px;
  padding: 10px 10px;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  /deep/ .input-value {
    padding: 5px 10px;
  }
}

.input-orthodontics {
  width: 19.3%;

  /deep/ .input-label {
    text-align: left !important;
  }

  /deep/ .input-value {
    flex: 0 1 auto;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    padding: 2px 10px;
    border-radius: 4px;
    background-color: #ececec;
    width: 260px;
  }
}

.input-rush,
.input-cal {
  width: 20%;

  /deep/ .input-label {
    width: 110px;
    text-align: left !important;
  }
  /deep/ .input-value {
    flex: 0 1 auto;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    // padding: 2px 10px;
    border-radius: 4px;
    background-color: #ececec;
    width: 260px;
  }
}

.molar-Str{
  letter-spacing: 2px;
}

.jaw-Str{
  width: 120px;
  letter-spacing: 33px;
}

.canvasImg{
  margin: 1% 0 0 3%;
}
.pane-box{
  margin-top: 5px;
}
</style>
<style lang="scss">
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background: #00A5D5;
}

.el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: inherit !important;
}
</style>


// WEBPACK FOOTER //
// orthodonticsOrderDetail.vue?2d34c4cb